<template>
  <div class="baidu-map-list-detail-template">
    <div class="header">
      <span class="back-btn" @click="goback">< 返回</span>案例详情
    </div>
    <div class="body">
      <p class="title">{{ data.assetname }}</p>
      <p class="address">所在地址：{{ data.address }}</p>
      <ul class="detail-info">
        <li v-for="item in data.detail">
          <span class="label">{{ item.label }}</span>
          <span class="value">{{ item.value }}</span>
        </li>
      </ul>
    </div>
    <div class="footer">
      <a :href="data.weburl" target="_blank">原始地址</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 选项卡
      typeEnums: {
        justice: {
          api: "map_getAuctionDetail",
          // 展示的详情格式
          detailInfo: {
            buildingarea: "建筑面积",
            landarea: "土地面积",
            buildingtype: "建筑类型",
            selltype: "出让形式",
            staringprice: "起始价",
            consultprice: "评估价",
            amount: "成交价",
            averageprice: "均价",
            premium: "溢价",
            deposit: "保证金",
            raiseprice: "加价幅度",
            staringdate: "开始时间",
            enddate: "结束时间",
            dealDate: "成交时间",
            stage: "拍卖阶段"
          }
        },
        estate: {
          api: "map_getEstateDetail",
          // 展示的详情格式
          detailInfo: {
            currentprice: "成交价",
            unitprice: "单位价",
            listingprice: "挂牌价",
            endtime: "成交时间",
            transactioncycle: "成交周期",
            innerarea: "使用面积",
            builtera: "建成年代",
            constructionarea: "建筑面积",
            buildingtype: "建筑类型",
            buildingstructure: "建筑结构",
            elevatorflag: "加价幅度",
            staringdate: "是否有电梯",
            houseorientation: "房子方位",
            renovationcondition: "装修情况",
            heatingmethod: "供暖方式",
            ladderratio: "梯户比例",
            tradingauthority: "交易属性",
            yearlimit: "产权年限",
            houselimit: "房屋年限"
          }
        }
      },

      initCfg: {
        listApi: ""
      },
      query: {
        keyword: ""
      },
      //
      data: {
        assetname: "",
        address: "",
        weburl: "",
        detail: []
      }
    };
  },
  methods: {
    search(type, id) {
      const apiUrl = this.typeEnums[type].api;
      const param = { id };

      this.$request[apiUrl](param).then(res => {
        // let { assetname = "", title = "", address = "", weburl, lng, lat } = res.detail;
        let data = [];

        if (type === "justice") {
          data = this.uploadJustice(type, res.detail);
        } else if (type === "estate") {
          data = this.uploadEstate(type, res.detail);
        }

        this.data = data;

        this.$emit("on-update-coordinate", { lng: data.lng, lat: data.lat });
      });
    },

    // 装载司法数据
    uploadJustice(type, res) {
      let { assetname = "", address = "", weburl, lng, lat } = res;
      let result = {};
      let data = [];

      result["assetname"] = assetname;
      result["address"] = address;
      result["weburl"] = weburl;
      result["lng"] = lng;
      result["lat"] = lat;

      Object.keys(this.typeEnums[type].detailInfo).forEach(key => {
        data.push({
          label: this.typeEnums[type].detailInfo[key],
          value: res[key]
        });
      });
      result.detail = data;

      return result;
    },

    // 装载司法数据
    uploadEstate(type, res) {
      let { title = "", itemurl = "", lng, lat } = res;
      let result = {};
      let data = [];

      result["assetname"] = title;
      // result["address"] = address;
      result["weburl"] = itemurl;
      result["lng"] = lng;
      result["lat"] = lat;

      Object.keys(this.typeEnums[type].detailInfo).forEach(key => {
        data.push({
          label: this.typeEnums[type].detailInfo[key],
          value: res[key]
        });
      });
      result.detail = data;

      return result;
    },

    // 获取详情
    goback() {
      this.clear();
      this.$emit("on-show-list");
    },

    clear() {
      this.data.assetname = "";
      this.data.address = "";
      this.data.weburl = "";
      this.data.detail = [];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
